<template>
    <div v-show="warningVisible">
        <input type="hidden" id="timerState">
        <div class="row">
            <div class="col-lg-12">
                <div class="alert alert-warning" style="font-size: 14px">
                    <vue-countdown :time="time" :transform="transformSlotProps" v-slot="{ minutes, seconds }">
                        <i class="far fa-clock"></i> {{ __('session_will_be_expired') }} {{ minutes }}:{{ seconds }}. <a
                        class="alert-link" @click="prolongSession">{{ __('prolong_session') }} &gt;&gt;</a>
                    </vue-countdown>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VueCountdown from '@chenfengyuan/vue-countdown';
import axios from "axios";
import $ from 'jquery'

export default {
    name: "Timer",
    components: {VueCountdown},
    data: function () {
        return {
            checkingTimer: null,
            warningTimer: null,
            logoutTimer: null,
            warningVisible: false,
            timeToWarning: 3300000,
            timeToLogout: 300000,
            time: 3600000,
            lastActivityAt: 0,
            activityThrottle: 60000,
        }
    },
    methods: {
        startWarningTimer: function () {
            this.warningTimer = setTimeout(this.warningHandler, this.timeToWarning);
        },
        startLogoutTimer: function () {
            this.logoutTimer = setTimeout(this.logoutHandler, this.timeToLogout);
        },
        warningHandler: function () {
            this.showWarning();
        },
        logoutHandler: function () {
            axios.post("/logout").then(function() {
            	window.location.href = "/loggedOut";
            }).catch(function(error) {
                window.location.href = "/loggedOut";
            });
        },
        showWarning: function () {
            this.warningVisible = true;
            $('.wrapper-content').css('margin-top', '20px');
            this.time = this.timeToLogout;
            this.startLogoutTimer();
        },
        hideWarning: function () {
            this.warningVisible = false;
            $('.wrapper-content').css('margin-top', '70px');
        },
        restartWarningTimer: function () {
            this.hideWarning();
            this.clearWarningTimer();
            this.startWarningTimer();
        },
        prolongSession: function () {
            const self = this;
            axios.post("/prolong-session")
                .then(function () {
                    self.restartWarningTimer();
                    self.clearLogoutTimer();
                });
        },
        clearWarningTimer: function () {
            clearTimeout(this.warningTimer);
            this.warningTimer = null;
        },
        clearLogoutTimer: function () {
            clearTimeout(this.logoutTimer);
            this.logoutTimer = null;
        },
        handleUserActivity: function (event) {
            const now = Date.now();
            const remaining = this.activityThrottle - (now - this.lastActivityAt);
            if (remaining > 0) {
                console.log('[Timer] activity throttled, next prolong in', Math.ceil(remaining / 1000), 's', '| event:', event.type);
                return;
            }
            this.lastActivityAt = now;
            console.log('[Timer] prolonging session | event:', event.type);
            this.prolongSession();
        },
        transformSlotProps(props) {
            const formattedProps = {};
            Object.entries(props).forEach(([key, value]) => {
                formattedProps[key] = value < 10 ? `0${value}` : String(value);
            });
            return formattedProps;
        },
    },
    mounted: function () {
        const self = this;
        self.startWarningTimer();
        $('#timerState').on('change', function () {
            self.prolongSession();
        });
        const activityEvents = ['mousedown', 'keypress', 'input', 'touchstart', 'click'];
        activityEvents.forEach(function (event) {
            document.addEventListener(event, self.handleUserActivity, { passive: true });
        });
        document.addEventListener('scroll', self.handleUserActivity, { passive: true, capture: true });
    },
    beforeDestroy: function () {
        const self = this;
        const activityEvents = ['mousedown', 'keypress', 'input', 'touchstart', 'click'];
        activityEvents.forEach(function (event) {
            document.removeEventListener(event, self.handleUserActivity);
        });
        document.removeEventListener('scroll', self.handleUserActivity, { capture: true });
    },
}
</script>

<style scoped>

</style>
